import {
    currencyFormatMask,
    getMinorUnitDigits,
} from "@/common/utilities/money/currencyPrecision";
import DineroFactory, { Currency } from "dinero.js";

/**
 * Wraps an amount in minor units (cents, yen, fils) as a Dinero object with the
 * precision its currency actually uses.
 *
 * Precision matters beyond formatting: `toUnit()` divides by it, and that is
 * what the price filters compare against their bounds. Building every amount at
 * Dinero's implicit 2 decimals made a ¥5,000 office read as 50.
 *
 * @param value The amount in the currency's minor unit.
 * @param currency ISO 4217 code.
 */
export const asCurrency = (value: number, currency: string) => {
    return DineroFactory({
        amount: value,
        currency: currency as Currency,
        precision: getMinorUnitDigits(currency),
    });
};

/**
 * An amount rendered for display, with the number of decimals its currency
 * uses: "€1,234.56", "¥1,235", "KD1,234.560".
 */
export const formatCurrency = (value: number, currency: string): string =>
    asCurrency(value, currency).toFormat(currencyFormatMask(currency));

/**
 * An amount rendered without decimals, for space-constrained places like the
 * price-filter slider labels.
 */
export const formatCurrencyWhole = (value: number, currency: string): string =>
    asCurrency(value, currency).toFormat("$0");
